import React from 'react';
import { Grid, Typography, Card, CardContent, useTheme} from '@mui/material';
import { CTBox, StyledGrid, StyledH3Heading, StyledH5Heading } from '../style/StyledComponents';
import { head } from 'lodash';

const features = [
  {
    heading: "Timestamped notes",
    content: "When you mark important sections, your notes will be saved along with the timestamps."
  },
  {
    heading: "Export notes",
    content: "Export notes in different formats such as PDF, MarkDown (md), txt etc. You will also be able to export notes for your faviorate note taking app such as Obsidian, Logseq, OneNote, Notion etc."
  },
  {
    heading: "Loop/Unloop and Highlight notes",
    content: "You can also loop/unloop and highlight the marked section and notes."
  },
  {
    heading: "AI Features coming soon...",
    content: "We are working on adding AI features such as automatic transcription and notes generation."
  }
];

const PodcastFeatures = () => {
  const theme = useTheme();

  return (
    <>
      <CTBox sx={{padding: "2rem"}}>
        <StyledH3Heading>Features</StyledH3Heading>
        <StyledGrid container spacing={2}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <StyledH5Heading>{feature.heading}</StyledH5Heading>
                  <Typography variant="body1" component="div" dangerouslySetInnerHTML={{ __html: feature.content }} />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </StyledGrid>
      </CTBox>
    </>
  );
};

export default PodcastFeatures;